module.exports = __webpack_public_path__ + "img/defactor.e7a12793.png";